<template> 
  <div> 
    <div class="d-flex flex-stack flex-wrap">
        <div class="page-title d-flex flex-column me-3 mt-3"> 
            <h1 class="d-flex text-gray-800 fw-bolder my-1 fs-3">Update Description Type 
            </h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">Home</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">Settings</router-link></li>  
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'GeneralSettings' }">General Settings</router-link></li>  
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'ListTypes' }">List Types</router-link></li>   
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'DescriptionTypeList' }">Description Type</router-link></li> 
                <li class="breadcrumb-item text-gray-600">Update Description Type</li> 
            </ul> 
        </div>  
        <div class="d-flex align-items-center py-1">
            <router-link to="/DescriptionTypeList">
                <button type="button" class="btn btn-light shadow-sm btn-arrow-left border border-gray-400 me-3">
                    <span class="ms-2 fs-7"> Return back to List</span>
                </button>
            </router-link> 
            &nbsp;
            <div class="dropdown">
                <button class="btn btn-light-info border border-info dropdown-toggle" type="button" @click="this.isOpenActionsDropdown = !this.isOpenActionsDropdown;">
                <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                </svg></span>
                    Actions
                </button>
                <ul class="dropdown-menu" :class="{ 'show': this.isOpenActionsDropdown }"> 
                    <li>
                        <a class="dropdown-item fs-4 text-danger" href="#" @click="deleteType(form.id)"><span class="svg-icon svg-icon-muted svg-icon-2 text-danger"><svg width="24" height="24" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="currentColor"/>
                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="currentColor"/>
                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="currentColor"/>
                        </svg>
                        </span>Delete </a>
                    </li>
                </ul>
            </div>  
        </div>
    </div>
    <div class="content flex-row-fluid mt-6" id="kt_content">
        <RequiredField></RequiredField>
        <div class="row">
            <div class="tab-content" id="myTabContent">
                <div class="card card-xxl-stretch tab-pane fade show active" id="kt_accounting_1" role="tabpanel">
                    <div class="p-10">
                        <div class="row">
                            <div class="col-lg-12 mt-0"> 
                                <div class="d-flex flex-row row">
                                    <div class="d-flex flex-column flex-row-auto col-lg-6"> 
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            Code
                                                        </label>
                                                        <input type="text" class="form-control " name="code"
                                                            v-model="form.code">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            Name
                                                        </label>
                                                        <input type="text" class="form-control " name="name"
                                                            v-model="form.name">
                                                    </div>
                                                </div> 
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="d-flex flex-column flex-row-auto col-lg-6"> 
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body">
                                                <div class="row">      
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            Type
                                                        </label>
                                                        <Select2 v-model="form.type_id" :options="descriptionTypeList" :settings="{ width: '100%' }"/>
                                                    </div>  
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            Description Location
                                                        </label> 
                                                        <Select2 v-model="form.description_location" :options="locationList" @select="this.form.location_detail = 0" :settings="{ width: '100%' }"/>
                                                    </div>
                                                    <div class="col-lg-12" v-if="this.locationDetailListByType.length > 1">
                                                        <label class="fs-6 fw-bold form-label mt-3 required">
                                                            Location Detail
                                                        </label> 
                                                        <Select2 v-model="form.location_detail" :options="locationDetailListByType" :settings="{ width: '100%' }"/>
                                                    </div>
                                                </div> 
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="d-flex flex-column flex-row-auto col-lg-12"> 
                                        <div class="d-flex flex-column-fluid card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-lg-6" v-if="this.form.description_location == 0 || this.form.description_location == 3 || this.form.description_location == 4 
                                                        || this.form.description_location == 7 || this.form.description_location == 8 || this.form.description_location == 9 || this.form.description_location == 11">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>Account Type</span>
                                                        </label> 
                                                        <Select2 v-model="form.account_type" :options="accountTypeList" :settings="{ width: '100%' }"/>
                                                    </div>
                                                    <div class="col-lg-6" v-if="this.form.description_location == 1">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>Sales Type</span>
                                                        </label> 
                                                        <Select2 v-model="form.sales_type" :options="salesTypeList" :settings="{ width: '100%' }"/>
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>Reg. Code</span>
                                                        </label> 
                                                        <input type="text" class="form-control " name="name"
                                                            v-model="form.registration_code">
                                                    </div>
                                                    <div class="col-lg-6">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>Control Code</span>
                                                        </label> 
                                                        <input type="text" class="form-control " name="name"
                                                            v-model="form.control_code">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <label class="fs-6 fw-bold form-label mt-3">
                                                            <span>Description</span>
                                                        </label> 
                                                        <textarea rows="3" class="form-control " name="description" v-model="form.description"></textarea>
                                                    </div>
                                                </div> 
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="d-grid gap-2">
                                    <button type="button" class="btn btn-primary" @click="this.saveData()" data-kt-indicator="on">
                                        <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                        </svg>
                                        </span> 
                                        <strong v-if="!this.isProgressing"> Update Description Type </strong> 
                                            <span class="indicator-progress" v-if="this.isProgressing">
                                                Saving Data... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                    </button>
                                </div>                  
                            </div>
                        </div>
                    </div> 
                </div> 
            </div>
        </div>
    </div>
  </div>
</template>
<script>
// Component Alias: `EXTU001`
import axios from 'axios' 

import Swal from 'sweetalert2';

 
export default {
  name: "DescriptionTypeUpdate",
  data() {
    return {
        isOpenActionsDropdown: false,
        descriptionTypeList: [
            { id: 0, text: 'Select an option' },
            { id: 1, text: 'Manuel' },
            { id: 2, text: 'Automatic' }
        ],
        locationList: [
            { id: -1, text: 'Select an option' },
            { id: 0, text: 'ALL' },
            { id: 1, text: 'Invoice'},
            { id: 2, text: 'Fixed Asset'},
            { id: 3, text: 'Cash'},
            { id: 4, text: 'Bank' },
            { id: 5, text: 'Expense' },
            { id: 6, text: 'Cheque' },
            { id: 7, text: 'Offsetting'},
            { id: 8, text: 'Turnover' },
            { id: 9, text: 'Difference' },
            // { id: 10, text: 'Amortization' },
            { id: 11, text: 'VAT' },
            { id: 12, text: 'Cost Of Sales'},
            { id: 13, text: 'Cost Of Production'},
            { id: 14, text: 'Opening Operations'},
            { id: 15, text: 'Closing Operations'},
            { id: 16, text: 'Profit & Loss Operations'},
            { id: 17, text: 'VAT Operations'},
            { id: 18, text: 'Accounting Voucher Operations'},
        ],
        locationDetailList: [
            { id: 0, text: 'ALL'},
            { id: 1, text: 'Sales', type: 1},
            { id: 2, text: 'Purchase', type: 1},
            { id: 3, text: 'Sales Return', type: 1},
            { id: 4, text: 'Purchase Return', type: 1},
            { id: 1, text: 'Incoming', type: 2},
            { id: 2, text: 'Outgoing', type: 2},
            { id: 1, text: 'Debit', type: 3},
            { id: 2, text: 'Credit', type: 3},
            { id: 1, text: 'Income Closing', type: 4},
            { id: 2, text: 'Expense Closing', type: 4},
            { id: 3, text: 'Cost Closing', type: 4},
            { id: 4, text: 'Other Income Closing', type: 4},
            { id: 5, text: 'Other Expense Closing', type: 4},
        ],
        salesTypeList: [
            { id: 0, text: 'Select an option'},
            { id: 1, text: 'Domestic'},
            { id: 2, text: 'Overseas'},           
        ],
        accountTypeList: [
            { id: 0, text: 'ALL'},
            { id: 1, text: 'Customer' },
            { id: 2, text: 'Supplier' },
            { id: 3, text: 'Cash' },
            { id: 4, text: 'Bank' },
            { id: 5, text: 'Personnel' },
            { id: 6, text: 'Expense' },
            { id: 7, text: 'Stock' },
            { id: 8, text: 'Fixed Asset' },
            { id: 15, text: 'Other Account' }
        ], 
        isProgressing: false,
        form: { 
            id: null,
            name: null,
            code: null,
            description: null,
            session_id: null,
            type_id: 0,
            description_location: 0,
            location_detail: 0,
            sales_type: 0,
            account_type: 0,
            registration_code: null,
            control_code: null
        }
    };
  },
  computed: {
    locationDetailListByType(){
        if(this.form.description_location == 1){ 
            return this.locationDetailList.filter(p => { 
                return p.type == 1 || p.id == 0;
            });
        } 
        else if(this.form.description_location == 2 || this.form.description_location == 3 || this.form.description_location == 4 || this.form.description_location == 6 || this.form.description_location == 11){ 
            return this.locationDetailList.filter(p => { 
                return p.type == 2 || p.id == 0;
            });
        } 
        else if(this.form.description_location == 8 || this.form.description_location == 9 || this.form.description_location == 7 || this.form.description_location == 18){ 
            return this.locationDetailList.filter(p => { 
                return p.type == 3 || p.id == 0;
            });
        }
        else if(this.form.description_location == 16){ 
            return this.locationDetailList.filter(p => { 
                return p.type == 4 || p.id == 0;
            });
        }
        else {
            return this.locationDetailList.filter(p => { 
                return p.id == 0;
            });
        }
    }
  },
  methods: {
    getData() {
        this.$setSessionStorage('refreshList', true);   
        const parameters = {
            id: this.$getSessionStorage("record_id"),
            session_id: this.$getUser().session_id,
            tip: 19
        };  
        
        const requestOne =  axios.post('/api/Lists/GetDescriptionTypeById', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/Lists/GetConst', parameters, {'Content-Type': 'application/json'}); 
        
        axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
            this.form = { 
                id: responses[0].data.id,
                name: responses[0].data.name,
                code: responses[0].data.code,
                description: responses[0].data.description,
                type_id: responses[0].data.type_id,
                description_location: responses[0].data.description_location,
                location_detail: responses[0].data.location_detail,
                sales_type: responses[0].data.sales_type,
                account_type: responses[0].data.account_type,
                registration_code: responses[0].data.registration_code,
                control_code: responses[0].data.control_code
            };
            this.locationList = responses[1].data;
            this.locationList.unshift({id: -1, text: 'Select an option'});
        }))
        .catch(errors => { 
            console.error(errors); 
        });
    },
    saveData(){
      this.isProgressing = true;
      const params = this.form; 
      const that = this;   
      params.session_id = this.$getUser().session_id;
      axios.post('/api/Lists/UpdateDescriptionType', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(response.data != null && response.data.length == 36){   
                this.$swal("Success", "Data saved succesfully..!", 'success');    
                this.$setSessionStorage('refreshList', true);    
            }
        })
        .catch(function (error) {
            console.error(error);
            this.$swal("Failed", "Data could not be saved..Please refresh the page and try again..!", "error");   
        }) 
        .finally(function () { 
            setTimeout(() => {
                that.isProgressing = false;
            }, 500);
        }); 
    },
      deleteType(id) { 
          this.$swal.fire({
              title: 'Are you sure you want to delete this data?',
              confirmButtonColor: '#f1416c',
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: 'Yes',
              icon: 'warning'
          }).then((result) => { 
              if (result.isConfirmed) {
              const queryParameter = {
                  id: id,
                  session_id: this.$getUser().session_id,
              }; 
              axios.post('/api/Lists/DeleteDescriptionType', queryParameter, {'Content-Type': 'application/json'})
                  .then(() => {   
                    new Swal( { icon: 'error', title: 'Deleted...', text: 'Data deleted..!' });
                    this.$setSessionStorage('refreshList', true);
                    this.$router.push({ name: 'DescriptionTypeList' }); 
                  })
                  .catch(function (error) {
                      console.error(error);
                  });
              }
          })  
      }
  },
  created() {
    this.$setSessionStorage('refreshList', true)
    this.getData();
  }
}; 
</script>